import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { ModalBaseTitle } from "./auth-service-tools296.js";
import { useDrawerContext } from "./auth-service-tools365.js";
import classes from "./auth-service-tools364.js";
const defaultProps = {};
const DrawerTitle = factory((_props, ref) => {
  const props = useProps("DrawerTitle", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    ...others
  } = props;
  const ctx = useDrawerContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(ModalBaseTitle, {
    ref,
    ...ctx.getStyles("title", {
      classNames,
      style,
      styles,
      className
    }),
    ...others
  });
});
DrawerTitle.classes = classes;
DrawerTitle.displayName = "@mantine/core/DrawerTitle";
export { DrawerTitle };